export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5183.5e329df8.jpg";